import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { useAuth } from '../../contexts/AuthContext';
import { ShoppingBag, Package, FileDown } from 'lucide-react';

export const Abschriften = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  const basePath = isAdmin ? '/admin' : '/employee';

  const cards = [
    {
      title: 'Backshop Abschriften',
      description: 'Abschriften für Backwaren und Backshop-Produkte',
      icon: ShoppingBag,
      color: 'text-orange-600',
      bgColor: 'bg-orange-50 dark:bg-orange-950/40',
      borderColor: 'border-orange-200 dark:border-orange-800',
      onClick: () => navigate(`${basePath}/abschriften/backshop`)
    },
    {
      title: 'Allgemeine Abschriften',
      description: 'Abschriften für alle anderen Produkte',
      icon: Package,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50 dark:bg-blue-950/40',
      borderColor: 'border-blue-200 dark:border-blue-800',
      onClick: () => navigate(`${basePath}/abschriften/allgemein`)
    }
  ];

  // Admin gets additional Export card
  if (isAdmin) {
    cards.push({
      title: 'Abschrift-Export',
      description: 'Abschriften als PDF exportieren',
      icon: FileDown,
      color: 'text-green-600',
      bgColor: 'bg-green-50 dark:bg-green-950/40',
      borderColor: 'border-green-200 dark:border-green-800',
      onClick: () => navigate(`${basePath}/abschriften/export`)
    });
  }

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold" style={{fontFamily: 'Manrope, sans-serif'}}>
            Abschriften
          </h1>
          <p className="text-muted-foreground mt-2">
            Verwaltung von Abschriften und Warenverlusten
          </p>
        </div>

        <div className={`grid gap-6 ${isAdmin ? 'md:grid-cols-3' : 'md:grid-cols-2'}`}>
          {cards.map((card, index) => {
            const Icon = card.icon;
            return (
              <Card 
                key={index}
                className={`cursor-pointer hover:shadow-lg transition-all duration-200 border-2 ${card.borderColor} hover:scale-[1.02]`}
                onClick={card.onClick}
              >
                <CardHeader className="pb-3">
                  <div className={`w-12 h-12 rounded-lg ${card.bgColor} flex items-center justify-center mb-3`}>
                    <Icon className={`h-6 w-6 ${card.color}`} />
                  </div>
                  <CardTitle className="text-xl">{card.title}</CardTitle>
                  <CardDescription>{card.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <div className={`text-sm ${card.color} font-medium flex items-center gap-1`}>
                    Öffnen →
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </DashboardLayout>
  );
};
